import React, { useRef, FunctionComponent } from "react";
import SignatureCanvas from "react-signature-canvas";
import * as Styled from "./styles";
import { BodyMediumRegular } from "../font";
import { tokens } from "@manifesthhqinc/ui-library";

export type SignaturePadProps = {
  updateSignatureDataURL: (...args: any) => void;
  errorText?: string;
};

export type Ref = HTMLDivElement | any;

const SignaturePad: FunctionComponent<SignaturePadProps> = ({ updateSignatureDataURL, errorText = "" }) => {
  const signaturePad = useRef<any | null>(null);

  const onEndHandler = () => {
    if (signaturePad.current) {
      updateSignatureDataURL(signaturePad.current.toDataURL());
    }
  };

  const onEraseSignature = () => {
    if (signaturePad.current) {
      signaturePad.current.clear();
      updateSignatureDataURL("");
    }
  };
  return (
    <>
      <Styled.CanvasContainer $isError={!!errorText}>
        <SignatureCanvas
          ref={signaturePad}
          onEnd={onEndHandler}
          clearOnResize
          canvasProps={{
            width: 312,
            height: 166,
          }}
        />
        <Styled.DottedLineContainer>
          <Styled.DottedLine />
        </Styled.DottedLineContainer>
      </Styled.CanvasContainer>

      <Styled.ClearSignatureButton onClick={onEraseSignature}>clear</Styled.ClearSignatureButton>
      {errorText && <BodyMediumRegular $color={tokens.color.text.error}>{errorText}</BodyMediumRegular>}
    </>
  );
};

export default SignaturePad;
